import { Link } from "react-router-dom";
import { ErrorPage } from "./error-page";

// Fallback for unknown routes (and a genuine API 404 from the legacy screens).
// Server trouble has its own page (server-error-page.tsx) — do not reuse that copy here.
const description = "요청하신 페이지를 찾을 수 없습니다. 주소를 다시 확인하거나 홈으로 이동해 주세요.";

export function NotFoundPage() {
  return (
    <ErrorPage
      code="Error 404"
      title="Not Found"
      description={description}
      illustration="not-found"
      action={
        <Link to="/" className="text-h2 font-normal text-black underline underline-offset-4">
          홈으로 이동
        </Link>
      }
    />
  );
}
